<div class="notification-container">
  <div
    *ngFor="let notification of notifications"
    class="notification"
    [ngClass]="notification.type">
    <span>{{ notification.message }}</span>
    <button (click)="removeNotification(notification.message)"
    aria-label="Cerrar notificación">✖</button>
  </div>
</div>
